export const tts = [
  'Filiz',
  'Astrid',
  'Tatyana',
  'Maxim',
  'Carmen',
  'Ines',
  'Cristiano',
  'Vitoria',
  'Ricardo',
  'Maja',
  'Jan',
  'Jacek',
  'Ewa',
  'Ruben',
  'Lotte',
  'Liv',
  'Seoyeon',
  'Takumi',
  'Mizuki',
  'Giorgio',
  'Carla',
  'Bianca',
  'Karl',
  'Dora',
  'Mathieu',
  'Celine',
  'Chantal',
  'Penelope',
  'Miguel',
  'Mia',
  'Enrique',
  'Conchita',
  'Geraint',
  'Salli',
  'Matthew',
  'Kimberly',
  'Kendra',
  'Justin',
  'Joey',
  'Joanna',
  'Ivy',
  'Raveena',
  'Aditi',
  'Emma',
  'Brian',
  'Amy',
  'Russell',
  'Nicole',
  'Vicki',
  'Marlene',
  'Hans',
  'Naja',
  'Mads',
  'Gwyneth',
  'Zhiyu',
  'Tracy',
  'Danny',
  'Huihui',
  'Yaoyao',
  'Kangkang',
  'HanHan',
  'Zhiwei',
  'Asaf',
  'An',
  'Stefanos',
  'Filip',
  'Ivan',
  'Heidi',
  'Herena',
  'Kalpana',
  'Hemant',
  'Matej',
  'Andika',
  'Rizwan',
  'Lado',
  'Valluvar',
  'Linda',
  'Heather',
  'Sean',
  'Michael',
  'Karsten',
  'Guillaume',
  'Pattara',
  'Jakub',
  'Szabolcs',
  'Hoda',
  'Naayf',
];
